// extracted by mini-css-extract-plugin
export var headerSection = "AgendaHeading-module--headerSection--2LQfE";
export var backgroundImageWrapper = "AgendaHeading-module--backgroundImageWrapper--16Vnv";
export var headingContentWrapper = "AgendaHeading-module--headingContentWrapper--8Av89";
export var headingContent = "AgendaHeading-module--headingContent--2oYxe";
export var heading = "AgendaHeading-module--heading--F9CRA";
export var paragraph = "AgendaHeading-module--paragraph--JcJqA";
export var headingButton = "AgendaHeading-module--headingButton--2I0U2";